export const STATUS_COLORS = {
  Success: { color: "green" },
  Failed: { color: "red" },
  "No submissions": { color: "gray" },
};
